import { fg } from '@atlaskit/platform-feature-flags';

//https://switcheroo.atlassian.com/ui/gates/30d75a94-370c-43aa-8931-79253af61396/key/is_deal_owners_enabled_in_ui
export default {
	get(): boolean {
		return fg('is_deal_owners_enabled_in_ui');
	},
};
